import { DatePicker, DatePickerProps } from 'antd'
import colors from 'core/resources/theme/colors'
import moment from 'moment'
import { useState } from 'react'
import { BiChevronDown, BiChevronUp } from 'react-icons/bi'
import { Container } from './styles'

interface SelectMonthYearProps {
  bg?: string
  format?: string
}

function SelectMonthYear({
  style,
  format = 'YYYY',
  ...rest
}: SelectMonthYearProps & DatePickerProps) {
  const [open, setOpen] = useState(false)

  const styles: any = {
    minWidth: 200,
    backgroundColor: rest.bg,
    ...style
  }

  if (rest.bg) {
    styles.border = '1px solid #ccc'
  }
  return (
    <Container>
      <DatePicker
        allowClear={false}
        format={format}
        monthCellRender={date => (
          <div className="ant-picker-cell-inner">
            {moment(date).format('MMM')}
          </div>
        )}
        locale={{
          timePickerLocale: {
            placeholder: 'Selecione um horário'
          },
          lang: {
            locale: 'pt-br',
            today: 'Hoje',
            now: 'Agora',
            backToToday: 'Voltar a hoje',
            clear: 'Limpar',
            month: 'Mês',
            year: 'Ano',
            dateFormat: 'DD/MM/YYYY',
            timeSelect: 'Selecione um horário',
            dateSelect: 'Selecione uma data',
            monthSelect: 'Selecione um mês',
            decadeSelect: 'Escolha uma década',
            yearFormat: 'YYYY',
            monthFormat: 'MMMM',
            dayFormat: 'DD',
            dateTimeFormat: 'DD/MM/YYYY HH:mm:ss',
            monthBeforeYear: true,
            previousMonth: 'Mês anterior',
            nextMonth: 'Próximo mês',
            previousYear: 'Ano anterior',
            nextYear: 'Próximo ano',
            previousDecade: 'Década anterior',
            nextDecade: 'Próxima década',
            previousCentury: 'Século anterior',
            nextCentury: 'Próximo século',
            placeholder: 'Selecione uma data',
            yearSelect: 'Selecione um ano',
            shortMonths: [
              'Jan',
              'Fev',
              'Mar',
              'Abr',
              'Mai',
              'Jun',
              'Jul',
              'Ago',
              'Set',
              'Out',
              'Nov',
              'Dez'
            ],
            weekSelect: 'Selecione uma semana',
            shortWeekDays: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
            ok: 'Ok'
          },
          monthFormat: 'MMM',
          dateFormat: 'DD MMM YYYY'
        }}
        picker="year"
        suffixIcon={
          open ? (
            <BiChevronUp size={20} color={colors.black} />
          ) : (
            <BiChevronDown size={20} color={colors.black} />
          )
        }
        style={styles}
        open={open}
        onOpenChange={setOpen}
        {...rest}
      />
    </Container>
  )
}

export default SelectMonthYear
